/* @ngInject */

export default (
  $rootScope,
  helperService,
  helperPdfService,
  YesNoOption,
  ImportantOption
) => {
  /**
   * Prepare objectives details.
   *
   * @param {Object} objectives
   * @param {Array} contacts
   * @param {Object} workflow
   *
   * @returns {Object}
   */
  const prepareObjectivesDetails = ({ objectives, contacts, workflow }) => {
    const content = [];
    const filteredContacts = _.filter(contacts || [], (c) => !c?.isCompany);
    if (objectives) {
      content.push(
        helperPdfService.createHeader({
          title: 'NEEDS AND OBJECTIVES',
          pageBreak: 'before'
        })
      );
      // #region Needs and objectives
      if (!workflow?.isAssetFinance()) {
        content.push({
          table: {
            widths: ['100%'],
            body: [
              [
                {
                  text: [
                    {
                      text:
                        'Please state primary reasons for seeking credit/your needs & objectives\n',
                      style: 'label'
                    },
                    {
                      text: objectives?.needsAndObjectives?.notes || '-',
                      style: 'value'
                    }
                  ]
                }
              ],
              [
                {
                  text: [
                    {
                      text:
                        'Immediate Needs & Objectives - within the next two years (e.g. holiday, purchases, renovations, savings, protect the family etc.)\n',
                      style: 'label'
                    },
                    {
                      text:
                        objectives?.needsAndObjectives?.immediateNeedsAndObjectivesNotes || '-',
                      style: 'value'
                    }
                  ]
                }
              ],
              [
                {
                  text: [
                    {
                      text:
                        'Longer term – between 2 to 10 yearsʼ time (e.g. repay mortgage, buy a new car, education expenses, purchase investment property, retirement planning etc.)\n',
                      style: 'label'
                    },
                    {
                      text: objectives?.needsAndObjectives?.longerTermNotes || '-',
                      style: 'value'
                    }
                  ]
                }
              ]
            ]
          },
          layout: 'noBorders'
        });
      }
      // #endregion

      // #region Requirements and objectives
      if (!workflow?.isAssetFinance()) {
        content.push({
          text: '',
          margin: [0, 20, 0, 0]
        });
        content.push(
          helperPdfService.createHeader({
            title: 'REQUIREMENTS AND OBJECTIVES',
            pageBreak: ''
          })
        );
        content.push(
          helperPdfService.createSubHeader({
            title: 'Loan purpose type',
            bodyStyle: ['subSubHeader']
          })
        );
        content.push({
          table: {
            widths: ['50%', '50%'],
            body: [
              [
                {
                  text: [
                    {
                      text: 'Owner occupier\n',
                      style: 'label'
                    },
                    {
                      text: objectives?.requirementsAndObjectives?.purposeType?.isOwnerOccupier
                        ? 'Yes'
                        : 'No',
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    {
                      text: 'Investment\n',
                      style: 'label'
                    },
                    {
                      text: objectives?.requirementsAndObjectives?.purposeType?.isInvestment
                        ? 'Yes'
                        : 'No',
                      style: 'value'
                    }
                  ]
                }
              ]
            ]
          },
          layout: 'noBorders'
        });
        const purposeDetails = {
          purchaseProperty: 'Purchase a property',
          construction: 'Construction',
          renovations: 'Renovations',
          investmentPurposes: 'Investment purposes',
          purchaseAsset: 'Purchase a motor vehicle, boat, trailer etc.',
          refinance: 'Refinance',
          debtConsolidation: 'Debt consolidation',
          other: 'Other'
        };
        let showPurposeDetails = false;
        Object.keys(purposeDetails).forEach((key) => {
          if (objectives?.requirementsAndObjectives?.purposeDetails[key]) {
            showPurposeDetails = true;
          }
        });
        if (showPurposeDetails) {
          content.push(
            helperPdfService.createSubHeader({
              title: 'Purpose',
              bodyStyle: ['subSubHeader']
            })
          );
          content.push({
            table: {
              widths: ['50%', '50%'],
              body: []
            },
            layout: 'noBorders'
          });
          Object.keys(purposeDetails).forEach((key) => {
            if (objectives?.requirementsAndObjectives?.purposeDetails[key]) {
              content[content.length - 1].table.body.push([
                {
                  text: [
                    {
                      text: `${purposeDetails[key]}\n`,
                      style: 'label'
                    },
                    {
                      text: 'Yes',
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    {
                      text: 'Amount\n',
                      style: 'label'
                    },
                    {
                      text: helperService
                        .isNumber(
                          objectives?.requirementsAndObjectives?.purposeDetails[
                            `${key}Amount`
                          ] || 0,
                          true
                        )
                        .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                      style: 'value'
                    }
                  ]
                }
              ]);
            }
          });
          content[content.length - 1].table.body.push([
            '',
            {
              text: [
                {
                  text: 'Total\n',
                  style: 'label'
                },
                {
                  text: helperService
                    .isNumber(
                      objectives?.requirementsAndObjectives?.purposeDetails?.totalAmount || 0,
                      true
                    )
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            }
          ]);
        }
        if (
          objectives?.requirementsAndObjectives?.purposeDetails?.refinance ||
          objectives?.requirementsAndObjectives?.purposeDetails?.debtConsolidation
        ) {
          const refinanceTheExistingLoan = {
            reducedRepayments: 'Reduced repayments',
            lowerInterestRate: 'Lower interest rate',
            increaseTotalLoanAmount: 'Increase total loan amount',
            greaterFlexibility:
              'Greater flexibility/ extra or specific loan features under new loan',
            reduceNumberOfLenders: 'Wants to reduce number of lenders/consolidate debts',
            dissatisfiedWithOtherFinancialInstitution:
              'Dissatisfied with other financial institution'
          };
          let showRefinanceTheExistingLoan = false;
          Object.keys(refinanceTheExistingLoan).forEach((key) => {
            if (objectives?.requirementsAndObjectives?.refinanceAndDebtConsolidation[key]) {
              showRefinanceTheExistingLoan = true;
            }
          });
          if (showRefinanceTheExistingLoan) {
            content.push(
              helperPdfService.createSubHeader({
                title: 'Why does the applicant(s) want to refinance the existing loan?',
                bodyStyle: ['subSubHeader']
              })
            );
            content.push({
              table: {
                widths: ['50%', '50%'],
                body: []
              },
              layout: 'noBorders'
            });
            Object.keys(refinanceTheExistingLoan).forEach((key) => {
              if (objectives?.requirementsAndObjectives?.refinanceAndDebtConsolidation[key]) {
                content[content.length - 1].table.body.push([
                  {
                    text: [
                      {
                        text: `${refinanceTheExistingLoan[key]}\n`,
                        style: 'label'
                      },
                      {
                        text: 'Yes',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      {
                        text: 'Details\n',
                        style: 'label'
                      },
                      {
                        text:
                          objectives?.requirementsAndObjectives?.refinanceAndDebtConsolidation[
                            `${key}Comments`
                          ] || '-',
                        style: 'value'
                      }
                    ]
                  }
                ]);
              }
            });
            if (objectives?.requirementsAndObjectives?.purposeDetails?.debtConsolidation) {
              let creditCardReducedOrCancelled = '-';
              if (objectives?.requirementsAndObjectives?.creditCardReducedOrCancelled) {
                creditCardReducedOrCancelled =
                  objectives?.requirementsAndObjectives?.creditCardReducedOrCancelled === 1
                    ? 'Yes'
                    : 'No';
              }
              content[content.length - 1].table.body.push([
                {
                  text: [
                    {
                      text: 'Will existing credit card limits be reduced or cancelled?\n',
                      style: 'label'
                    },
                    {
                      text: creditCardReducedOrCancelled,
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    {
                      text:
                        objectives?.requirementsAndObjectives?.creditCardReducedOrCancelled ===
                        1
                          ? 'Details\n'
                          : '\n',
                      style: 'label'
                    },
                    {
                      text:
                        objectives?.requirementsAndObjectives?.creditCardReducedOrCancelled ===
                        1
                          ? objectives?.requirementsAndObjectives
                              ?.creditCardReducedOrCancelledComments || '-'
                          : '',
                      style: 'value'
                    }
                  ]
                }
              ]);
            }
          }
        }
      }
      // #endregion

      // #region Possible adverse changes to financial situation
      content.push({
        text: '',
        margin: [0, 20, 0, 0]
      });
      content.push(
        helperPdfService.createHeader({
          title: workflow?.isAssetFinance()
            ? 'POSSIBLE CHANGES TO BORROWERS FINANCIAL SITUATION'
            : 'POSSIBLE ADVERSE CHANGES TO FINANCIAL SITUATION',
          pageBreak: ''
        })
      );
      content.push({
        table: {
          widths: ['100%'],
          body: [
            [
              {
                text: [
                  {
                    text: workflow?.isAssetFinance()
                      ? 'Do the applicant(s) plan or anticipate any changes to their future financial position that could either adversely or beneficially impact their ability to repay the loan?\n'
                      : 'Do the applicant(s) plan or anticipate changes to their future financial circumstances that could ADVERSELY Impact their ability to repay the loan?\n',
                    style: 'label'
                  },
                  {
                    text:
                      objectives?.possibleAdverseChangesToFinancialSituation
                        ?.planChangesToTheirFinancialCircumstances?.name !==
                      YesNoOption.none.name
                        ? objectives?.possibleAdverseChangesToFinancialSituation
                            ?.planChangesToTheirFinancialCircumstances?.title || '-'
                        : '-',
                    style: 'value'
                  }
                ]
              }
            ]
          ]
        },
        layout: 'noBorders'
      });

      if (
        !workflow?.isAssetFinance() &&
        objectives?.possibleAdverseChangesToFinancialSituation
          ?.planChangesToTheirFinancialCircumstances
      ) {
        const eSLen = filteredContacts?.length || 0;
        if (eSLen) {
          let pABodyContent = 0;
          content.push(
            helperPdfService.createSubHeader({
              title:
                'Specify to which applicant(s) the changes apply and answer the remaining questions for all applicants together.',
              bodyStyle: ['subSubHeader']
            })
          );
          content.push({
            table: {
              widths: ['16.6%', '16.6%', '16.6%', '16.6%', '16.6%', '16.6%'],
              body: []
            },
            layout: 'noBorders'
          });
          for (let c = 0; c < eSLen; c += 1) {
            const contact = filteredContacts[c];
            if (!contact.isCompany) {
              if (c === 0 || c === 6 || c === 12 || c === 18 || c === 24 || c === 30) {
                content[content.length - 1].table.body.push(['', '', '', '', '', '']);
                pABodyContent = 0;
              }
              content[content.length - 1].table.body[
                content[content.length - 1].table.body.length - 1
              ][pABodyContent] = {
                text: [
                  {
                    text: `${contact.getName()}\n`,
                    style: 'label'
                  },
                  {
                    text: objectives?.possibleAdverseChangesToFinancialSituation?.applicants[c]
                      ?.isChanged
                      ? 'Yes'
                      : 'No',
                    style: 'value'
                  }
                ]
              };
              pABodyContent += 1;
            }
          }
        }
        const natureOfPlannedChange = {
          extendedUnpaidLeave: 'Extended unpaid leave (e.g. parental leave)',
          reducedIncome: 'Reduced income',
          endOfContract: 'End of contract/loss of employment',
          leavingEmployment: 'Leaving employment',
          increasedDebtRepayments: 'Increased debt repayment(s) for an existing loan',
          largeExpenditure: 'Large expenditure',
          medicalTreatment: 'Medical treatment/illness',
          other: 'Other'
        };
        let showNatureOfPlannedChange = false;
        Object.keys(natureOfPlannedChange).forEach((key) => {
          if (
            objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange[key]
          ) {
            showNatureOfPlannedChange = true;
          }
        });
        if (showNatureOfPlannedChange) {
          content.push(
            helperPdfService.createSubHeader({
              title: 'What is the nature of the planned or anticipated change?',
              bodyStyle: ['subSubHeader']
            })
          );
          content.push({
            table: {
              widths: ['45%', '15%', '15%', '25%'],
              body: []
            },
            layout: 'noBorders'
          });
          Object.keys(natureOfPlannedChange).forEach((key) => {
            if (
              objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange[key]
            ) {
              content[content.length - 1].table.body.push([
                {
                  text: [
                    {
                      text: `${natureOfPlannedChange[key]}\n`,
                      style: 'label'
                    },
                    {
                      text: 'Yes',
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    {
                      text: 'From date\n',
                      style: 'label'
                    },
                    {
                      text: helperService.getDate({
                        timeStamp:
                          objectives?.possibleAdverseChangesToFinancialSituation
                            ?.natureOfPlannedChange[`${key}FromDate`]
                      }),
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    {
                      text: 'To date\n',
                      style: 'label'
                    },
                    {
                      text: helperService.getDate({
                        timeStamp:
                          objectives?.possibleAdverseChangesToFinancialSituation
                            ?.natureOfPlannedChange[`${key}ToDate`]
                      }),
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    {
                      text: 'Financial impact per month\n',
                      style: 'label'
                    },
                    {
                      text: helperService
                        .isNumber(
                          objectives?.possibleAdverseChangesToFinancialSituation
                            ?.natureOfPlannedChange[`${key}FinancialImpact`],
                          true
                        )
                        .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                      style: 'value'
                    }
                  ]
                }
              ]);
            }
          });
          if (
            objectives?.possibleAdverseChangesToFinancialSituation?.natureOfPlannedChange?.other
          ) {
            content[content.length - 1].table.body.push([
              {
                text: [
                  {
                    text: 'Other details\n',
                    style: 'label'
                  },
                  {
                    text:
                      objectives?.possibleAdverseChangesToFinancialSituation
                        ?.natureOfPlannedChange?.otherComments || '-',
                    style: 'value'
                  }
                ],
                colSpan: 3
              },
              '',
              '',
              ''
            ]);
          }
        }
        const applicantsIntendToMeetLoanRepayments = {
          additionalIncomeSource: 'Additional income source',
          reduceExpenditure: 'Reduce expenditure',
          saleOfAssets: 'Sale of assets',
          savingsAndSuperannuation:
            'Savings and/or Superannuation (please give details if not already captured in Financials)',
          coApplicantsIncome:
            "Co-applicant's income (please give details if not already captured in Financials)",
          other: 'Other'
        };
        let showApplicantsIntendToMeetLoanRepayments = false;
        Object.keys(applicantsIntendToMeetLoanRepayments).forEach((key) => {
          if (
            objectives?.possibleAdverseChangesToFinancialSituation
              ?.applicantsIntendToMeetLoanRepayments[key]
          ) {
            showApplicantsIntendToMeetLoanRepayments = true;
          }
        });
        if (showApplicantsIntendToMeetLoanRepayments) {
          content.push(
            helperPdfService.createSubHeader({
              title:
                'How do the applicant(s) intend to meet their loan repayments following the planned or anticipated change(s)?',
              bodyStyle: ['subSubHeader']
            })
          );
          content.push({
            table: {
              widths: ['45%', '15%', '15%', '25%'],
              body: []
            },
            layout: 'noBorders'
          });
          Object.keys(applicantsIntendToMeetLoanRepayments).forEach((key) => {
            if (
              objectives?.possibleAdverseChangesToFinancialSituation
                ?.applicantsIntendToMeetLoanRepayments[key]
            ) {
              content[content.length - 1].table.body.push([
                {
                  text: [
                    {
                      text: `${applicantsIntendToMeetLoanRepayments[key]}\n`,
                      style: 'label'
                    },
                    {
                      text: 'Yes',
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    {
                      text: 'Details\n',
                      style: 'label'
                    },
                    {
                      text:
                        objectives?.possibleAdverseChangesToFinancialSituation
                          ?.applicantsIntendToMeetLoanRepayments[`${key}Comments`] || '-',
                      style: 'value'
                    }
                  ],
                  colSpan: 3
                },
                '',
                ''
              ]);
            }
          });
        }
      }
      // #endregion

      // #region Exit strategy
      if (!workflow?.isAssetFinance()) {
        content.push({
          text: '',
          margin: [0, 20, 0, 0]
        });
        content.push(
          helperPdfService.createHeader({
            title: 'EXIT STRATEGY',
            pageBreak: ''
          })
        );
        const eSLen = filteredContacts?.length || 0;
        if (eSLen) {
          let eSBodyApplicantContent = 0;
          content.push(
            helperPdfService.createSubHeader({
              title: 'At what age is the applicant(s) planning to retire?',
              bodyStyle: ['subSubHeader']
            })
          );
          content.push({
            table: {
              widths: ['16.6%', '16.6%', '16.6%', '16.6%', '16.6%', '16.6%'],
              body: []
            },
            layout: 'noBorders'
          });
          for (let c = 0; c < eSLen; c += 1) {
            const contact = filteredContacts[c];
            if (!contact.isCompany) {
              if (c === 0 || c === 6 || c === 12 || c === 18 || c === 24 || c === 30) {
                content[content.length - 1].table.body.push(['', '', '', '', '', '']);
                eSBodyApplicantContent = 0;
              }
              content[content.length - 1].table.body[
                content[content.length - 1].table.body.length - 1
              ][eSBodyApplicantContent] = {
                text: [
                  {
                    text: `${contact.getName()}\n`,
                    style: 'label'
                  },
                  {
                    text: objectives?.exitStrategy?.planingToRetire[c]?.ageToRetire || '-',
                    style: 'value'
                  }
                ]
              };
              eSBodyApplicantContent += 1;
            }
          }
        }
        const exitStrategy = {
          repaymentOfLoanPriorToRetirement: 'Repayment of loan prior to retirement',
          downsizingHome: 'Downsizing home',
          saleOfAssets: 'Sale of assets',
          recurringIncomeFromSuperannuation: 'Recurring income from superannuation',
          superAnnuationLumpSumFollowingRetirement:
            'Superannuation lump sum following retirement',
          savings: 'Savings',
          incomeFromOtherInvestments: 'Income from other investments',
          coApplicantsIncome: "Co-applicant's income",
          other: 'Other'
        };
        let showExitStrategy = false;
        Object.keys(exitStrategy).forEach((key) => {
          if (objectives?.exitStrategy?.applicantsProposeToRepayLoan[key]) {
            showExitStrategy = true;
          }
        });
        if (showExitStrategy) {
          content.push(
            helperPdfService.createSubHeader({
              title: 'How would the applicant(s) propose to repay the loan?',
              bodyStyle: ['subSubHeader']
            })
          );
          content.push({
            table: {
              widths: ['33.3%', '33.3%', '33.3%'],
              body: []
            },
            layout: 'noBorders'
          });
          let esCount = 0;
          let eSBodyContent = 0;
          Object.keys(exitStrategy).forEach((key) => {
            if (objectives?.exitStrategy?.applicantsProposeToRepayLoan[key]) {
              if (esCount === 0 || esCount === 3 || esCount === 6) {
                content[content.length - 1].table.body.push(['', '', '']);
                eSBodyContent = 0;
              }
              content[content.length - 1].table.body[
                content[content.length - 1].table.body.length - 1
              ][eSBodyContent] = {
                text: [
                  {
                    text: `${exitStrategy[key]}\n`,
                    style: 'label'
                  },
                  {
                    text: 'Yes',
                    style: 'value'
                  }
                ]
              };
              eSBodyContent += 1;
              esCount += 1;
            }
          });
          if (objectives?.exitStrategy?.applicantsProposeToRepayLoan?.other) {
            content[content.length - 1].table.body.push(['', '', '']);
            content[content.length - 1].table.body[
              content[content.length - 1].table.body.length - 1
            ][0] = {
              text: [
                {
                  text: 'Other details\n',
                  style: 'label'
                },
                {
                  text:
                    objectives?.exitStrategy?.applicantsProposeToRepayLoan?.otherComments ||
                    '-',
                  style: 'value'
                }
              ]
            };
          }
        }
      }
      // #endregion

      // #region Credit history
      if (!workflow?.isAssetFinance()) {
        content.push({
          text: '',
          margin: [0, 20, 0, 0]
        });
        content.push(
          helperPdfService.createHeader({
            title: 'CREDIT HISTORY',
            pageBreak: ''
          })
        );
        const creditHistory = {
          applicantHadProblems:
            'Has either applicant ever had any problems meeting any of your fixed commitments including mobile phone payments?',
          applicantBeenOfficerOrShareholder:
            'Has either applicant ever been an officer or shareholder of any company of which a manager, receiver, and/or liquidator has been appointed?',
          applicantHaveUnsatisfiedJudgements:
            'Does either applicant have any unsatisfied judgement(s) entered in any court against either applicant or any company of which either applicant are/were a Shareholder/Officer?',
          applicantSubmittedApplicationToOtherCreditProviders:
            'Have any applicants simultaneously applied to any other Credit Provider(s) for this loan?'
        };
        let showCreditHistory = false;
        Object.keys(creditHistory).forEach((key) => {
          if (objectives?.creditHistory[key]) {
            showCreditHistory = true;
          }
        });
        if (showCreditHistory) {
          content.push({
            table: {
              widths: ['100%'],
              body: [['']]
            },
            layout: 'noBorders'
          });
          Object.keys(creditHistory).forEach((key) => {
            if (objectives?.creditHistory[key]?.name !== YesNoOption.none.name) {
              content[content.length - 1].table.body.push([
                {
                  text: [
                    {
                      text: `${creditHistory[key]}\n`,
                      style: 'label'
                    },
                    {
                      text: objectives?.creditHistory[key]?.title,
                      style: 'value'
                    }
                  ]
                }
              ]);
              if (objectives?.creditHistory[key]?.name === YesNoOption.yes.name) {
                content[content.length - 1].table.body.push([
                  {
                    text: [
                      {
                        text: 'Comments\n',
                        style: 'label'
                      },
                      {
                        text: objectives?.creditHistory[`${key}Comments`] || '-',
                        style: 'value'
                      }
                    ]
                  }
                ]);
              }
            }
          });
        }
        if (objectives?.creditHistory?.bankruptcy?.length) {
          const cHLen = filteredContacts?.length || 0;
          if (cHLen) {
            content.push({
              table: {
                widths: ['100%'],
                body: []
              },
              layout: 'noBorders'
            });
            for (let c = 0; c < cHLen; c += 1) {
              const contact = filteredContacts[c];
              if (!contact.isCompany) {
                content[content.length - 1].table.body.push(['']);
                content[content.length - 1].table.body[
                  content[content.length - 1].table.body.length - 1
                ][0] = {
                  text: [
                    {
                      text: `Has ${contact.getName()} ever been declared bankrupt?\n`,
                      style: 'label'
                    },
                    {
                      text:
                        objectives?.creditHistory?.bankruptcy[c]?.response?.name !==
                        YesNoOption?.none?.name
                          ? objectives?.creditHistory?.bankruptcy[c]?.response?.title
                          : '-',
                      style: 'value'
                    }
                  ]
                };
                if (
                  objectives?.creditHistory?.bankruptcy[c]?.response?.name ===
                  YesNoOption.yes.name
                ) {
                  content[content.length - 1].table.body.push(['']);
                  content[content.length - 1].table.body[
                    content[content.length - 1].table.body.length - 1
                  ][0] = {
                    text: [
                      {
                        text: 'Comments\n',
                        style: 'label'
                      },
                      {
                        text: objectives?.creditHistory?.bankruptcy[c]?.comments || '-',
                        style: 'value'
                      }
                    ]
                  };
                }
                if (
                  objectives?.creditHistory?.bankruptcy[c]?.response?.name ===
                  YesNoOption.yes_discharged.name
                ) {
                  content[content.length - 1].table.body.push(['']);
                  content[content.length - 1].table.body[
                    content[content.length - 1].table.body.length - 1
                  ][0] = {
                    text: [
                      {
                        text: 'Date discharged\n',
                        style: 'label'
                      },
                      {
                        text: helperService.getDate({
                          timeStamp:
                            objectives?.creditHistory?.bankruptcy[c]?.dischargedDate || 0,
                          dateFormat: $rootScope.CurrentDateFormatSecondary()
                        }),
                        style: 'value'
                      }
                    ]
                  };
                }
              }
            }
          }
        }
      }
      // #endregion

      // #region Credit history
      if (!workflow?.isAssetFinance()) {
        content.push({
          text: '',
          margin: [0, 20, 0, 0]
        });
        content.push(
          helperPdfService.createHeader({
            title: 'PRODUCT REQUIREMENTS',
            pageBreak: ''
          })
        );
        const getReasons = ({ productType, type }) => {
          let reasons = {};
          if (productType && type) {
            switch (type) {
              case 'fixed':
                reasons = {
                  avoidingRiskOfIncreasingVariableInterestRate:
                    'Avoiding risk of increasing variable interest rate during fixed interest period',
                  makeBudgetingEasier: 'Make budgeting easier',
                  other: 'Other'
                };
                break;
              case 'variable':
                reasons = {
                  advantageOfPotentialFuture:
                    'To take advantage of potential future decreases in the interest rate',
                  flexibilityWithRespectToRepayment:
                    'Flexibility with respect to repayment, redraw and/or early repayment of loan',
                  other: 'Other'
                };
                break;
              case 'fixedAndVariable':
                reasons = {
                  limitingRisk:
                    'Limiting risk of increasing variable interest rate to obtain some benefit from potential future decreases in the interest rate',
                  retainingDegree:
                    'Retaining a degree of flexibility in relation to increased repayments, redraws and/or early repayment of part of the loan',
                  easierBudgeting:
                    'Make budgeting easier than if the entire loan were variable',
                  other: 'Other'
                };
                break;
              case 'principalAndInterest':
                reasons = {
                  minimiseInterestPaid: 'Minimise interest paid over life of loan',
                  higherLendingLimit: 'Higher lending limit',
                  lowerDepositRequired: 'Lower deposit required',
                  buildUpEquity: 'Build up equity from the start',
                  other: 'Other'
                };
                break;
              case 'interestOnly':
                reasons = {
                  accommodateTemporaryReduction:
                    'Accommodate temporary reduction in income (e.g. parental leave, changing circumstances)',
                  accommodateAnticipated:
                    'Accommodate anticipated nonrecurring expense item (e.g. education, renovation/construction, furniture)',
                  variableAndUnpredictableIncome: 'Variable and unpredictable income',
                  recommendationProvidedBy:
                    'Recommendation provided by an independent financial advisor/accountant',
                  taxationOrAccountingReasons:
                    'Taxation or accounting reasons (no tax advice is being given), including',
                  other: 'Other'
                };
                break;
              case 'interestInAdvance':
                reasons = {
                  taxPurposes: 'For tax purposes (no tax advice is being given)',
                  discountsOnInterestRate: 'Discounts on interest rate',
                  assistWithCashFlow: 'To assist with cash flow and budgeting',
                  other: 'Other'
                };
                break;
              case 'lineOfCredit':
                reasons = {
                  assistsWithInvestmentPurchases:
                    'Assists with investment purchases and tax planning (no tax advice is being given)',
                  anticipatedVariableCashFlows: 'Anticipated variable cash flows',
                  allowsAccessToFundsAtAnyTime: 'Allows access to funds at any time',
                  flexibilityToManageRepayments: 'Flexibility to manage repayments',
                  noNeedToApply: 'No need to apply for further lending in future',
                  ongoingNeedForFunds:
                    'Ongoing need for funds – planning to make a few purchases over a period of time',
                  other: 'Other'
                };
                break;
              case 'offsetAccount':
                reasons = {
                  allowsPayingOffLoanSooner: 'Allows paying off the loan sooner',
                  allowsAccessToFunds: 'Allows access to funds',
                  taxPurposes: 'For tax purposes (no tax advice is being given)',
                  other: 'Other'
                };
                break;
              case 'redraw':
                reasons = {
                  accessPrepaidFunds: 'Flexibility to access prepaid funds if needed',
                  other: 'Other'
                };
                break;
              default:
                break;
            }
          }
          return reasons;
        };

        const rateType = {
          fixed: 'Fixed rate',
          variable: 'Variable rate',
          fixedAndVariable: 'Fixed and variable rate'
        };
        let showRateType = false;
        Object.keys(rateType).forEach((key) => {
          if (
            objectives?.rateType[key]?.type?.name !== ImportantOption.none.name &&
            !showRateType
          ) {
            showRateType = true;
          }
        });
        if (showRateType) {
          content.push(
            helperPdfService.createSubHeader({
              title: 'RATE TYPE',
              bodyStyle: ['subHeader']
            })
          );
          Object.keys(rateType).forEach((key) => {
            if (objectives?.rateType[key]?.type?.name !== ImportantOption.none.name) {
              content.push(
                helperPdfService.createSubHeader({
                  title: `${rateType[key]}`,
                  bodyStyle: ['subSubHeader']
                })
              );
              content.push({
                table: {
                  widths: ['50%', '50%'],
                  body: [['', '']]
                },
                layout: 'noBorders'
              });
              content[content.length - 1].table.body[
                content[content.length - 1].table.body.length - 1
              ][0] = {
                text: [
                  {
                    text: `${rateType[key]}\n`,
                    style: 'label'
                  },
                  {
                    text: objectives?.rateType[key]?.type?.title(),
                    style: 'value'
                  }
                ]
              };
              if (objectives?.rateType[key]?.type?.name === ImportantOption.important.name) {
                if (key !== 'variable') {
                  content[content.length - 1].table.body[
                    content[content.length - 1].table.body.length - 1
                  ][1] = {
                    text: [
                      {
                        text: 'Indicate the preferred duration of the fixed rate period\n',
                        style: 'label'
                      },
                      {
                        text: objectives?.rateType[key]?.preferredDuration?.title,
                        style: 'value'
                      }
                    ]
                  };
                }
                const reasons = getReasons({
                  productType: 'rateType',
                  type: key
                });
                let showReasons = false;
                Object.keys(reasons).forEach((subKey) => {
                  if (objectives?.rateType[key]?.reason[subKey]) {
                    showReasons = true;
                  }
                });
                if (showReasons) {
                  content.push(
                    helperPdfService.createSubHeader({
                      title: `Where ${rateType[key].toLowerCase()} is important, why?`,
                      bodyStyle: ['subSubSubHeader']
                    })
                  );
                  content.push({
                    table: {
                      widths: ['50%', '50%'],
                      body: [['', '']]
                    },
                    layout: 'noBorders'
                  });
                  let rBodyContent = 0;
                  Object.keys(reasons).forEach((subKey) => {
                    if (objectives?.rateType[key]?.reason[subKey]) {
                      if (
                        content[content.length - 1].table.body[
                          content[content.length - 1].table.body.length - 1
                        ][0] !== '' &&
                        content[content.length - 1].table.body[
                          content[content.length - 1].table.body.length - 1
                        ][1] !== ''
                      ) {
                        content[content.length - 1].table.body.push(['', '']);
                        rBodyContent = 0;
                      }
                      content[content.length - 1].table.body[
                        content[content.length - 1].table.body.length - 1
                      ][rBodyContent] = {
                        text: [
                          {
                            text: `${reasons[subKey]}\n`,
                            style: 'label'
                          },
                          {
                            text: 'Yes',
                            style: 'value'
                          }
                        ]
                      };
                      rBodyContent += 1;
                    }
                  });
                  if (objectives?.rateType[key]?.reason?.other) {
                    content[content.length - 1].table.body.push(['', '']);
                    content[content.length - 1].table.body[
                      content[content.length - 1].table.body.length - 1
                    ][0] = {
                      text: [
                        {
                          text: 'Other details\n',
                          style: 'label'
                        },
                        {
                          text: objectives?.rateType[key]?.reason?.otherComments || '-',
                          style: 'value'
                        }
                      ],
                      colSpan: 2
                    };
                  }
                }
              }
            }
          });
        }

        const repaymentType = {
          principalAndInterest: 'Principal and interest',
          interestOnly: 'Interest only',
          interestInAdvance: 'Interest in advance',
          lineOfCredit: 'Line of credit'
        };
        let showRepaymentType = false;
        Object.keys(repaymentType).forEach((key) => {
          if (
            objectives?.repaymentType[key]?.type?.name !== ImportantOption.none.name &&
            !showRepaymentType
          ) {
            showRepaymentType = true;
          }
        });
        if (showRepaymentType) {
          content.push({
            text: '',
            margin: [0, 10, 0, 0]
          });
          content.push(
            helperPdfService.createSubHeader({
              title: 'REPAYMENT TYPE',
              bodyStyle: ['subHeader']
            })
          );
          Object.keys(repaymentType).forEach((key) => {
            if (objectives?.repaymentType[key]?.type?.name !== ImportantOption.none.name) {
              content.push(
                helperPdfService.createSubHeader({
                  title: `${repaymentType[key]}`,
                  bodyStyle: ['subSubHeader']
                })
              );
              content.push({
                table: {
                  widths: ['33.3%', '33.3%', '33.3%'],
                  body: [['', '', '']]
                },
                layout: 'noBorders'
              });
              content[content.length - 1].table.body[
                content[content.length - 1].table.body.length - 1
              ][0] = {
                text: [
                  {
                    text: `${repaymentType[key]}\n`,
                    style: 'label'
                  },
                  {
                    text: objectives?.repaymentType[key]?.type?.title(),
                    style: 'value'
                  }
                ]
              };
              if (
                objectives?.repaymentType[key]?.type?.name === ImportantOption.important.name
              ) {
                if (key === 'interestOnly') {
                  content[content.length - 1].table.body[
                    content[content.length - 1].table.body.length - 1
                  ][1] = {
                    text: [
                      {
                        text: 'Indicate the preferred duration of the interest only period\n',
                        style: 'label'
                      },
                      {
                        text: objectives?.repaymentType[key]?.preferredDuration?.title,
                        style: 'value'
                      }
                    ]
                  };
                }
                if (key === 'principalAndInterest' || key === 'interestOnly') {
                  content[content.length - 1].table.body[
                    content[content.length - 1].table.body.length - 1
                  ][key === 'principalAndInterest' ? 1 : 2] = {
                    text: [
                      {
                        text: 'Indicate preferred repayment frequency\n',
                        style: 'label'
                      },
                      {
                        text: objectives?.repaymentType[key]?.preferredPaymentFrequency?.title,
                        style: 'value'
                      }
                    ]
                  };
                }
                if (key === 'interestInAdvance') {
                  content[content.length - 1].table.body[
                    content[content.length - 1].table.body.length - 1
                  ][1] = {
                    text: [
                      {
                        text: 'Indicate the preferred duration of the interest only period\n',
                        style: 'label'
                      },
                      {
                        text: objectives?.repaymentType[key]?.isConfirmed?.title,
                        style: 'value'
                      }
                    ]
                  };
                }
                if (key === 'lineOfCredit') {
                  content[content.length - 1].table.body[
                    content[content.length - 1].table.body.length - 1
                  ][1] = {
                    text: [
                      {
                        text:
                          "What is the applicant's plan for paying off the line of credit at the end of or during the term?\n",
                        style: 'label'
                      },
                      {
                        text: objectives?.repaymentType[key]?.planForPayingLineOfCredit?.title,
                        style: 'value'
                      }
                    ]
                  };
                }
                const reasons = getReasons({
                  productType: 'repaymentType',
                  type: key
                });
                let showReasons = false;
                Object.keys(reasons).forEach((subKey) => {
                  if (objectives?.repaymentType[key]?.reason[subKey]) {
                    showReasons = true;
                  }
                });
                if (showReasons) {
                  content.push(
                    helperPdfService.createSubHeader({
                      title:
                        key === 'lineOfCredit'
                          ? 'Why is flexibility of drawdown and repayments important?'
                          : `Where ${repaymentType[key].toLowerCase()} is important, why?`,
                      bodyStyle: ['subSubSubHeader']
                    })
                  );
                  content.push({
                    table: {
                      widths: ['50%', '50%'],
                      body: [['', '']]
                    },
                    layout: 'noBorders'
                  });
                  let rTBodyContent = 0;
                  Object.keys(reasons).forEach((subKey) => {
                    if (objectives?.repaymentType[key]?.reason[subKey]) {
                      if (
                        content[content.length - 1].table.body[
                          content[content.length - 1].table.body.length - 1
                        ][0] !== '' &&
                        content[content.length - 1].table.body[
                          content[content.length - 1].table.body.length - 1
                        ][1] !== ''
                      ) {
                        content[content.length - 1].table.body.push(['', '']);
                        rTBodyContent = 0;
                      }
                      content[content.length - 1].table.body[
                        content[content.length - 1].table.body.length - 1
                      ][rTBodyContent] = {
                        text: [
                          {
                            text: `${reasons[subKey]}\n`,
                            style: 'label'
                          },
                          {
                            text: 'Yes',
                            style: 'value'
                          }
                        ]
                      };
                      rTBodyContent += 1;
                    }
                  });
                  if (objectives?.repaymentType[key]?.reason?.other) {
                    content[content.length - 1].table.body.push(['', '']);
                    content[content.length - 1].table.body[
                      content[content.length - 1].table.body.length - 1
                    ][0] = {
                      text: [
                        {
                          text: 'Other details\n',
                          style: 'label'
                        },
                        {
                          text: objectives?.repaymentType[key]?.reason?.otherComments || '-',
                          style: 'value'
                        }
                      ],
                      colSpan: 2
                    };
                  }
                  content[content.length - 1].table.body.push(['', '']);
                  content[content.length - 1].table.body[
                    content[content.length - 1].table.body.length - 1
                  ][0] = {
                    text: [
                      {
                        text:
                          'Provide further details to expand on the reason(s) for selecting interest only and advise why the interest only period meets the applicant’s requirements and objectives\n',
                        style: 'label'
                      },
                      {
                        text: objectives?.repaymentType[key]?.reason?.additionalComments || '-',
                        style: 'value'
                      }
                    ],
                    colSpan: 2
                  };
                }
              }
            }
          });
        }

        const productType = {
          offsetAccount: 'Offset account',
          redraw: 'Redraw'
        };
        let showProductType = false;
        Object.keys(productType).forEach((key) => {
          if (
            objectives?.productType[key]?.type?.name !== ImportantOption.none.name &&
            !showProductType
          ) {
            showProductType = true;
          }
        });
        if (showProductType) {
          content.push({
            text: '',
            margin: [0, 10, 0, 0]
          });
          content.push(
            helperPdfService.createSubHeader({
              title: 'PRODUCT TYPE',
              bodyStyle: ['subHeader']
            })
          );
          Object.keys(productType).forEach((key) => {
            if (objectives?.productType[key]?.type?.name !== ImportantOption.none.name) {
              content.push(
                helperPdfService.createSubHeader({
                  title: `${productType[key]}`,
                  bodyStyle: ['subSubHeader']
                })
              );
              content.push({
                table: {
                  widths: ['50%', '50%'],
                  body: [['', '']]
                },
                layout: 'noBorders'
              });
              content[content.length - 1].table.body[
                content[content.length - 1].table.body.length - 1
              ][0] = {
                text: [
                  {
                    text: `${productType[key]}\n`,
                    style: 'label'
                  },
                  {
                    text: objectives?.productType[key]?.type?.title(),
                    style: 'value'
                  }
                ]
              };
              if (
                objectives?.productType[key]?.type?.name === ImportantOption.important.name &&
                key !== 'offsetAccount'
              ) {
                content[content.length - 1].table.body[
                  content[content.length - 1].table.body.length - 1
                ][1] = {
                  text: [
                    {
                      text:
                        'Confirm each of the risks have been explained to the applicant(s)\n',
                      style: 'label'
                    },
                    {
                      text: objectives?.productType[key]?.isConfirmed?.title,
                      style: 'value'
                    }
                  ]
                };
              }
              const reasons = getReasons({
                productType: 'productType',
                type: key
              });
              let showReasons = false;
              Object.keys(reasons).forEach((subKey) => {
                if (objectives?.productType[key]?.reason[subKey]) {
                  showReasons = true;
                }
              });
              if (showReasons) {
                content.push(
                  helperPdfService.createSubHeader({
                    title:
                      key === 'offsetAccount'
                        ? 'Where having an offset account is important, why?'
                        : 'Where having a redraw feature is important, why?',
                    bodyStyle: ['subSubSubHeader']
                  })
                );
                content.push({
                  table: {
                    widths: ['50%', '50%'],
                    body: [['', '']]
                  },
                  layout: 'noBorders'
                });
                let pTBodyContent = 0;
                Object.keys(reasons).forEach((subKey) => {
                  if (objectives?.productType[key]?.reason[subKey]) {
                    if (
                      content[content.length - 1].table.body[
                        content[content.length - 1].table.body.length - 1
                      ][0] !== '' &&
                      content[content.length - 1].table.body[
                        content[content.length - 1].table.body.length - 1
                      ][1] !== ''
                    ) {
                      content[content.length - 1].table.body.push(['', '']);
                      pTBodyContent = 0;
                    }
                    content[content.length - 1].table.body[
                      content[content.length - 1].table.body.length - 1
                    ][pTBodyContent] = {
                      text: [
                        {
                          text: `${reasons[subKey]}\n`,
                          style: 'label'
                        },
                        {
                          text: 'Yes',
                          style: 'value'
                        }
                      ]
                    };
                    pTBodyContent += 1;
                  }
                });
                if (objectives?.productType[key]?.reason?.other) {
                  content[content.length - 1].table.body.push(['', '']);
                  content[content.length - 1].table.body[
                    content[content.length - 1].table.body.length - 1
                  ][0] = {
                    text: [
                      {
                        text: 'Other details\n',
                        style: 'label'
                      },
                      {
                        text: objectives?.productType[key]?.reason?.otherComments || '-',
                        style: 'value'
                      }
                    ],
                    colSpan: 2
                  };
                }
              }
            }
          });
        }
      }
      // #endregion
    }
    return content;
  };

  /**
   * Create objectives NZ details.
   *
   * @param {Object} objectives
   *
   * @returns {Object}
   */
  const prepareObjectivesNZDetails = ({ objectives }) => {
    const content = [];
    if (objectives && helperService.getOrganizationCountry().cca2 === 'NZ') {
      content.push(
        helperPdfService.createHeader({
          title: 'NEEDS AND OBJECTIVES',
          pageBreak: 'before'
        })
      );
      content.push(
        helperPdfService.createSubHeader({
          title: 'ACTING AS A GUARANTOR'
        })
      );
      content.push({
        table: {
          widths: ['16.6%', '16.6%', '16.6%', '16.6%', '16.6%', '16.6%'],
          body: [
            [
              {
                text: [
                  {
                    text: 'Are you guaranteeing a loan for any other person?\n',
                    style: 'label'
                  },
                  {
                    text: objectives?.actingAsAGuarantor?.guaranteeingLoan?.title,
                    style: 'value'
                  }
                ],
                colSpan: 3
              },
              '',
              '',
              '',
              '',
              ''
            ]
          ]
        },
        layout: 'noBorders'
      });
      if (objectives?.actingAsAGuarantor?.guaranteeingLoan?.name === YesNoOption.yes.name) {
        content[content.length - 1].table.body[0][3] = {
          text: [
            {
              text: 'Are you guaranteeing a loan for any other person?\n',
              style: 'label'
            },
            {
              text: objectives?.actingAsAGuarantor?.guaranteeingLoanComments || '-',
              style: 'value'
            }
          ],
          colSpan: 3
        };
      }
    }
    return content;
  };

  return {
    prepareObjectivesDetails,
    prepareObjectivesNZDetails
  };
};
